export const locales = ["en-GB","fr-FR"]
export const fileNamesByLang = {"en":"en","en-GB":"en","fr":"fr","fr-FR":"fr"}
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {"en":"en-GB","en-GB":"en-GB","fr":"fr-FR","fr-FR":"fr-FR"}
